import messageTypes from './types';

export const initialStates = {
	toasts: [],
};

const messagesReducers = (state = initialStates, action) => {
	switch (action.type) {
		case messageTypes.TOASTS.PUSH:
			return {
				...state,
				toasts: [...state.toasts, ...[action.payload]],
			};
		case messageTypes.TOASTS.POP:
			return {
				...state,
				toasts: state.toasts.filter((toast) => toast.id !== action.payload),
			};

		case messageTypes.TOASTS.CLEAR:
			return { ...state, toasts: [] };

		case messageTypes.TOASTS.CLEAR_NON_PERSISTANTS: {
			let persistToasts = state?.toasts?.filter((toast) => toast.persist);
			return { ...state, toasts: persistToasts };
		}

		default:
			return state;
	}
};

export default messagesReducers;
